export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_02_blank.cffeb9cd.png";